import { ThunkDispatch } from "../../store";
import { customerSearchResultLoaded ,availablePackagesOfCustomerLoaded,newPrivateClassDetailCreated} from "./actions";

export async function searchCustomerInfo (searchMethod:string,searchInput: any) {
    
    const res = await fetch(`${process.env.REACT_APP_API_SERVER}/customerParticipation/loadCustomerInfoBySearchingInput?searchMethod=${searchMethod}&searchInput=${searchInput}`, {
        method: 'GET',
        headers: {
            "Content-Type":"application/json",
            Authorization:`Bearer ${localStorage.getItem('token')}`,

        }
    })
    let result : any= await res.json();

    if(res.status === 500){
        return async (dispatch:ThunkDispatch) => {
            console.log(result);
        }
    } else {
        
        return async (dispatch:ThunkDispatch) => {
            
            dispatch(customerSearchResultLoaded(result.customerSearchResult));
            console.log(result)
        }
    }
}

export async function loadAvailablePackagesForAddingNewPrivateClass (customerID:number) {
    const res = await fetch(`${process.env.REACT_APP_API_SERVER}/customerParticipation/loadCustomerPackagesforAddingPrivateClassUse?customerID=${customerID}`, {
        method: 'GET',
        headers: {
            "Content-Type":"application/json",
            Authorization:`Bearer ${localStorage.getItem('token')}`,

        }
    });

    let result = await res.json();

    if(res.status === 500){
        return async (dispatch:ThunkDispatch) => {
            console.log(result);
        }
    } else {
        
        return async (dispatch:ThunkDispatch) => {
            
            dispatch(availablePackagesOfCustomerLoaded(result));
            console.log(result)
        }
    }

}

export async function createNewPrivateClassDetails (customerID:number, siteID:number, classroomID:number, startTime: any, endTime:any, tutorID:number, tokenPackageIDs: any[], bookingCount:number, fullyOccupying: boolean = true) {
    const res = await fetch(`${process.env.REACT_APP_API_SERVER}/schedule/newPrivateClassOccupancyAndTutorList`, {
        method: 'POST',
        headers: {
            "Content-Type":"application/json",
            Authorization:`Bearer ${localStorage.getItem('token')}`,

        },
        body: JSON.stringify({
            bookingCount: bookingCount,
            tokenPackageIDs: tokenPackageIDs,
            occupancyDetails : {
                site_id: siteID,
                classroom_id: classroomID,
                start_time: startTime,
                end_time:endTime,
                customer_id:customerID,
                tutor_id:tutorID,
                fully_occupying_space: fullyOccupying  // 新增
            }
        })
    });

    let result = await res.json();
    if(res.status === 500){
        return async (dispatch:ThunkDispatch) => {
            console.log(result);
        }
    } else {
        
        return async (dispatch:ThunkDispatch) => {
            dispatch(newPrivateClassDetailCreated());
            console.log(result)
        }
    }
}